import React, { useState, useRef, useEffect, useCallback } from 'react'
import { Site, Coordinates, BoundaryStyling, Name, Company, defaultCenter, handleTextFieldChange } from '../../components/Site Functions/LoadSiteData'
import { APISiteLoggerDetail } from '../../components/Site Functions/LoadSiteDetailsData'
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import Modal from 'react-bootstrap/Modal'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import TextField from '@mui/material/TextField';
import SiteDeviceChips from './SiteDeviceChips'
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';
import { GPS, dataLoader, fitBoundsToMarkers, renderChip, handleRemoveDeviceChipAndMarker, resetBoundaryAction, selectionChanged, onMapLoad, resetBoundary } from '../../components/Site Functions/LoadSiteModalData'
import moment from 'moment'
import { DataGrid, Column, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, Format, Export, HeaderFilter, Selection } from 'devextreme-react/data-grid';
import { Button, Checkbox, Chip, useTheme, Select, MenuItem, Slider } from '@mui/material';
import GoogleMapComponent from '../../components/Map/NewGoogleMaps2024';
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { MuiColorInput } from 'mui-color-input';
import CustomNumberInputChanger from '../../components/CustomInput/CustomNumberInputChanger'
import SlideInAnimation from '../../Animation Wrappers/SlideInAnimation';


interface Props {
    open:boolean
    modalTitle: string
    onCancel: () => void
    site: Site
    unAssignedLoggers: APISiteLoggerDetail[]
    selectedLogger: string | null
    editSite:  boolean
    handleLoggersToBeUnassigned: (logger: APISiteLoggerDetail) => void
    onSubmit: (
        selected: APILoggerDetail[],
        assignDate: Date,
        polygonPath: Coordinates[],
        boundaryStyling: BoundaryStyling,
        hasBoundary: boolean,
        tempName: Name,
        companyId: number)
        => void 
    companies: Company[]
}

const SiteModalMobile: React.FC<Props> = ({
    open,
    modalTitle,
    onCancel,
    site,
    unAssignedLoggers,
    selectedLogger,
    editSite,
    handleLoggersToBeUnassigned,
    onSubmit,
    companies

}) => {

    const intl = useIntl()
    const theme = useTheme()


    console.log(companies)



    const mapRef = useRef(null);
    const [markers, setMarkers] = useState<Array<GPS>>([])
    const [showGrid, setShowGrid] = useState<boolean>(false)
    const [selected, setSelected] = useState<Array<APISiteLoggerDetail>>([])
    const [fromDate, setFromDate] = useState(new Date())
    const [currentZoom, setCurrentZoom] = useState<number>(18)
    const [message, setMessage] = useState<boolean>(false)
    const [hasCreatedSite, setHasCreatedSite] = useState<boolean>(false)
    const [polygonPath, setPolygonPath] = useState<Coordinates[]>([]);
    const [center, setCenter] = useState<Coordinates>(defaultCenter);
    const [hasBoundary, setHasBoundary] = useState<boolean>(false)
    const [createBoundary, setCreateBoundary] = useState<boolean>(false)
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [boundaryStyling, setBoundaryStyle] = useState<BoundaryStyling>(
        {
            strokeWeight: 2,
            strokeColor: '#FF0000',
            areaColor: '#FF0000',
            transparency: 35
        })
    const [hoveredMarker, setHoveredMarker] = useState(null)
    const [uploadModal, setUploadModal] = useState<boolean>(false)
    //const [kml, setKml] = useState<KML>({ fileName: "", coordinates: [] })
    const [fileLoadError, setFileLoadError] = useState<boolean>(true)
    const [assignDate, setAssignDate] = useState<Date>(moment().toDate())
    const [tempName, setTempName] = useState<Name>({ siteNameTemp: "", siteRefTemp: "" })
    const [editBoundary, setEditBoundary] = useState<boolean>(false)
    const [updateBoundary, setUpdateBoundary] = useState<boolean>(false)
    const [showTooltip, setShowTooltip] = useState<boolean>(false)
    const [tooltipHovered, setTooltipHovered] = useState<boolean>(false)
    const [selectedCompany, setSelectedCompany] = useState<string>("")
    const [hideDefault, setHideDefault] = useState<boolean>(false)
    const [showMap, setShowMap] = useState<boolean>(false)

    useEffect(() => {
        if (site.loggers.length > 0) {
            const loggers: APISiteLoggerDetail[] = []
            site.loggers.forEach(log => loggers.push(buildAPILoggerDetail(log)))
            site.loggers = loggers
        }
        dataLoader(
            site,
            setPolygonPath,
            setHasBoundary,
            setBoundaryStyle,
            selectedLogger,
            unAssignedLoggers,
            setSelected,
            handleAddDeviceClick,
            setMarkers,
            setTempName,
            setSelectedCompany
        )
        console.log(editSite)
        
    }, [site, unAssignedLoggers])

    useEffect(() => {
        if (editSite) {
            setHasCreatedSite(true)
            setShowMap(true)
            setShowGrid(true)
        }
    }, [editSite])

    useEffect(() => {
        unAssignedLoggers.map(logger => {
            if (!logger.Latitude || !logger.Longitude) {
                logger.hasGps = false
            } else {
                logger.hasGps = true
            }
        })
    }, [unAssignedLoggers.length > 0])

    useEffect(() => {
        resetBoundaryAction(
            true,
            polygonPath,
            markers,
            setPolygonPath,
            setCenter
        )
        
    }, [markers])


    useEffect(() => {
        const timeout = setTimeout(() => {
            fitBoundsToMarkers(
                mapRef,
                markers,
                hasBoundary,
                createBoundary,
                polygonPath)
        }, 50);
        return () => clearTimeout(timeout)
    }, [markers, createBoundary, hasBoundary, updateBoundary])



    const handleAddDeviceClick = () => {
        setShowGrid(true)
    }

    const handleCompanySelect = (e) => {
        setSelectedCompany(e.target.value)
    }

    const handleCreateSite = () => {
        if (!selectedCompany) {
            setSelectedCompany(companies[0].name)
        }
        setHasCreatedSite(true)
        setShowGrid(true)
    }

    const chipClick = () => {
        //
    }

    const onPolygonClick = () => {
        /* do nothing */
    }

    const updatePolygonPath = useCallback((path) => {
        if (!path || typeof path.getLength !== 'function') return;

        const newCoordinates = [];
        const len = path.getLength();

        for (let i = 0; i < len; i++) {
            const point = path.getAt(i);
            newCoordinates.push({
                lat: point.lat(),
                lng: point.lng()
            });
        }

        // Force a new reference to trigger re-render
        setPolygonPath([...newCoordinates]);
    }, []);

    const handleTooltipShow = (serial: number): void => {

        setHoveredMarker(serial)
    }

    const handleTooltipHide = (): void => {
        setHoveredMarker(null)
    }


    const onMarkerClick = () => {
        if (unAssignedLoggers.length > 0) {
            handleAddDeviceClick()
        }
    }

    const handleRightVertexClick = (event): void => {


        const vertexIndex = event.vertex;
        if (vertexIndex !== undefined) {
            // Remove the vertex
            const updatedCoords = [...polygonPath];
            updatedCoords.splice(vertexIndex, 1);
            setPolygonPath(updatedCoords);
        }
    }

    const containerStyle = {
        height: "40vh",
        width: "100%"
    };

    const handleCreateBoundaryClick = (): void => {
        if (createBoundary) {
            resetBoundary(
                setHasBoundary,
                setPolygonPath,
                setBoundaryStyle,
                polygonPath,
                markers,
                setCenter
            )
        } else {
            setCreateBoundary(true)
            setEditBoundary(true)
        }
    }

    const closeModal = ():void => {
        setShowMap(false)
        setHasCreatedSite(false)
        setShowGrid(false)
        onCancel()
        setCreateBoundary(false)

    }

    const handleStylingChange = (name: string, value: string | number): void => {
        const styling: BoundaryStyling = { ...boundaryStyling }
        if (isNaN(value) && name === 'strokeWeight') {
            value = 0
        }
        styling[name] = value
        setBoundaryStyle(styling)
    }

    const handleUpdate = (): void => {

        const companyId = companies.filter(company => company.name === selectedCompany)[0].id
        setEditBoundary(false)
        setUpdateBoundary(false)
        setShowMap(false)
        setHasCreatedSite(false)
        setShowGrid(false)
        onSubmit(selected, assignDate, polygonPath, boundaryStyling, hasBoundary || createBoundary ? true : false, tempName, companyId)
        onCancel()
        setPolygonPath([])
        setHasBoundary(false)
        setCreateBoundary(false)
        setSelected([])
    }

    const handleLineWidthChange = (operator: string):void => {
        const styling = { ...boundaryStyling }
        if (operator === '+') {
            styling.strokeWeight = styling.strokeWeight + 1
        }
        if (operator === '-') {
            styling.strokeWeight = styling.strokeWeight - 1
        }
        setBoundaryStyle(styling)
    }


    return (
        <Modal
            show={open}
            style={{marginTop: 40} }
        >
            <Modal.Header>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div style={{display: "flex", marginBottom: 10} }>
                        <h4 style={{margin: "4px 8px 0 0", width: "200px"} }><FormattedMessage id='Site Name'/>:</h4>
                        <TextField
                            size="small"
                            fullWidth
                            onChange={(e): void => { handleTextFieldChange(e.target.name, e.target.value, tempName, setTempName) }}
                            name={"siteNameTemp"}
                            value={tempName.siteNameTemp }
                        />
                    </div>
                    <div style={{ display: "flex", marginBottom: 10 }}>
                        <h4 style={{ margin: "4px 8px 0 0", width: "200px" }}><FormattedMessage id='Site Ref'/>:</h4>
                        <TextField
                            size="small"
                            fullWidth
                            onChange={(e): void => { handleTextFieldChange(e.target.name, e.target.value, tempName, setTempName) }}
                            name={"siteRefTemp"}
                            value={tempName.siteRefTemp}
                        />
                    </div>
                    {companies?.length > 1 && !editSite &&
                        <div style={{ display: "flex", marginBottom: 10 }}>
                            <h4 style={{ margin: "4px 8px 0 0", width: "150px" }}><FormattedMessage id="Company" />:</h4>
                            <Select
                                size="small"
                                value={selectedCompany}
                                onChange={(e) => handleCompanySelect(e)}
                                style={{ width: "316px", background: "#ffffff" }}
                                defaultValue={companies[0].name}
                            >
                                {companies.map(company => {
                                    return (<MenuItem value={company.name} key={company.id}>{`${company.name} ${company.isParent ? '(' + intl.formatMessage({ id: 'Top Level' }) + ')' : '(' + intl.formatMessage({ id: 'Sub' }) + ')'}`}</MenuItem>)
                                })}

                            </Select>
                        </div>
                    }
                    {markers.length > 0 && <div>
                        <div style={{ display: "flex", marginBottom: 20 }}>
                            <h4 style={{ margin: "4px 8px 0 0", width: "150px" }}><FormattedMessage id='Devices'/>:</h4>
                            <SiteDeviceChips
                                deviceDetailsClick={chipClick}
                                data={markers}
                                deleteNeeded={true}
                                removeDevice={(logger: GPS): void => handleRemoveDeviceChipAndMarker(
                                    logger,
                                    markers,
                                    selected,
                                    site,
                                    intl,
                                    handleLoggersToBeUnassigned,
                                    setSelected,
                                    setMarkers,
                                    setPolygonPath,
                                    setHasBoundary,
                                    setCreateBoundary
                                )}
                                added={selected}
                            />
                        </div>
                        
                    </div>
                    }
                    {hasCreatedSite && <div style={{ width: "100%", marginBottom: 20 }}>
                        <FullWidthMobileButton disabled={!showMap && markers.length === 0} text={showMap ? intl.formatMessage({ id: "Add Devices" }) : intl.formatMessage({ id: "show on map" })} onClick={(): void => setShowMap(!showMap)} color="secondary" />
                    </div>}
                    
                    {!editSite && !hasCreatedSite && <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                        <div style={{width: "100%"} }>
                            <FullWidthMobileButton text={intl.formatMessage({ id: "Continue" })} color="primary" disabled={!tempName.siteNameTemp || !tempName.siteRefTemp} onClick={(): void => handleCreateSite()} />
                        </div>
                    </div>}
                    {(showGrid && hasCreatedSite) &&
                        <div style={{ width: "200%", display: "flex", transform: showMap ? "translateX(-50%)" : "translateX(0)", transition: 'transform 1s'}}>
                            <div style={{ width: "50%", opacity: showMap ? 0 : 1, transition: 'opacity 1s' }} >
                                <h4 style={{ textAlign: 'center' }}><b><FormattedMessage id='Add Devices' /></b></h4>
                                <DataGrid
                                    dataSource={unAssignedLoggers.filter(logger => logger.CompanyName === selectedCompany)}
                                    selectedRowKeys={selected}
                                    onSelectionChanged={(data): void => selectionChanged(
                                        data,
                                        markers,
                                        setSelected,
                                        setMarkers
                                    )}
                                    allowColumnResizing={true}
                                    allowColumnReordering={true}
                                    style={{ width: "100%" }}
                                >
                                    <Selection
                                        mode="multiple"
                                        selectAllMode='allPages'
                                        showCheckBoxesMode='always'
                                    />
                                    <FilterRow visible={true} />
                                    <StateStoring enabled={true} type="localStorage" storageKey="unAssignedDeviceListGrid" />
                                    <Column dataField="Serial" dataType="string" cellRender={(data): React.ReactNode => renderChip(data, intl)} width={140} caption={intl.formatMessage({ id: "Serial" })} />
                                    <Column dataField="DeviceName" dataType="string" caption={intl.formatMessage({ id: "Device Name" })} />
                                    <Column type="selection" caption={intl.formatMessage({ id: "Select" })} fixed={true} fixedPosition="right" />
                                    <Pager allowedPageSizes={[5, 10, 20, 50]} showPageSizeSelector={false} />
                                    <Paging defaultPageSize={5} />
                                </DataGrid>
                            </div>
                            <div style={{ width: "50%", opacity: showMap ? 1 : 0, transition: 'opacity 1s' }} >
                                <GoogleMapComponent
                                    //mapKey={mapKey}
                                    containerStyle={containerStyle}
                                    center={center}
                                    onMapLoad={(map): void => onMapLoad(
                                        map,
                                        mapRef,
                                        markers,
                                        hasBoundary,
                                        createBoundary,
                                        polygonPath
                                    )}
                                    markers={markers}
                                    hasBoundary={hasBoundary}
                                    createBoundary={createBoundary}
                                    polygonPath={polygonPath}
                                    boundaryStyling={boundaryStyling}
                                    onPolygonClick={onPolygonClick}
                                    updatePolygonPath={updatePolygonPath}
                                    handleMouseOverMarker={handleTooltipShow}
                                    handleMouseOutMarker={handleTooltipHide}
                                    onMarkerClick={onMarkerClick}
                                    hoveredMarker={hoveredMarker}
                                    editBoundary={editBoundary}
                                    showTooltip={true}
                                    handleRightVertexClick={handleRightVertexClick}
                                />
                                {createBoundary &&
                                    <SlideInAnimation direction="top" duration={0.8} delay={0} transitionAmount={100} isVisible={createBoundary}>
                                        <div style={{ width: "100%", }}>
                                            <div style={{ display: "flex", marginTop: "20px" }}>
                                                <h4 style={{ margin: "4px 8px 0 0", width: "150px" }}><FormattedMessage id="Area Colour" />:</h4>
                                                <MuiColorInput size="small" name="areaColor" value={boundaryStyling.areaColor} onChange={(e): void => handleStylingChange('areaColor', e)} />
                                            </div>
                                            <div style={{ display: "flex", marginTop: "10px" }}>
                                                <h4 style={{ margin: "4px 8px 0 0" }}><FormattedMessage id="Area Transparency" />:</h4>
                                                <Slider color="black" size="small" valueLabelDisplay="auto" style={{ width: "45%" }} value={boundaryStyling.transparency} onChange={(e, value): void => handleStylingChange('transparency', value)} />
                                            </div>
                                            <div style={{ display: "flex", marginTop: "10px" }}>
                                                <h4 style={{ margin: "4px 8px 0 0", width: "150px" }}><FormattedMessage id="Line Colour" />:</h4>
                                                <MuiColorInput size="small" name="strokeColor" value={boundaryStyling.strokeColor} onChange={(e): void => handleStylingChange('strokeColor', e)} />
                                            </div>
                                            <div style={{ display: "flex", margin: "10px 0 20px 0" }}>
                                                <h4 style={{ margin: "8px 8px 0 0", width: "150px" }}><FormattedMessage id="Line Width" />:</h4>
                                                <div style={{ display: "flex", width: "70%"}}>
                                                    <div style={{margin: "0 4px 0 0", width: "50%"}}>
                                                        <FullWidthMobileButton text="-" color="primary" onClick={():void => handleLineWidthChange('-')} disabled={false} />
                                                    </div>
                                                    <div style={{ margin: "0 0 0 4px", width: "50%" }}>
                                                        <FullWidthMobileButton text="+" color="primary" onClick={(): void => handleLineWidthChange('+')} disabled={false} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SlideInAnimation>
                                }
                                {console.log(polygonPath) }
                                {markers.length > 0 && <div style={{ width: "100%", marginTop: "10px" }}>
                                    <FullWidthMobileButton text={createBoundary ? intl.formatMessage({ id: "Reset Boundary" }) : editSite && !createBoundary ? intl.formatMessage({ id: "edit boundary" }) : intl.formatMessage({ id: "create boundary" })} color="warning" onClick={(): void => handleCreateBoundaryClick()} disabled={false} />
                                </div>}
                                
                            </div>
                        </div>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div style={{marginBottom: 10, width: "100%"} }>
                    <FullWidthMobileButton text={intl.formatMessage({ id: "Save" })} onClick={(): void => handleUpdate()} disabled={!tempName.siteNameTemp || !tempName.siteRefTemp || !selectedCompany} color="primary" />
                </div>
                <div style={{ width: "100%" }}>
                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Cancel" })} onClick={(): void => closeModal()} color="error" />
                </div>
            </Modal.Footer>
        </Modal>
    )
}
export default SiteModalMobile